// extracted by mini-css-extract-plugin
export default {"idInfo":"ItemBrowserHeaderSelect_idInfo__DwKrP"};